// extracted by mini-css-extract-plugin
export default {"wrapper":"CDoPX7Uy7TlDRsAlqNbs","wrapper_with_caption":"UaYJPG5lGxt8Zzm6d2aB"};